import React, { Component } from "react";
import { connect } from "react-redux";
import {
  updateModule,
  updatePage,
  addPageToBreadCrumbs,
} from "actions/siteTracking";
import { BillingUtils, BillingApi } from "services/billing";
import { INVOICE_SUMMARY_HEADERS } from "utils/BillingConstants";
import { UserProfileApi } from "services/userProfile";
import { TicketApi } from "services/ticket";
import { Utils } from "services/utils";
/** WIZARD SCREENS */

import BillingIssueSelection from "./BillingIssueSelection";
import ConfirmationPage from "./ConfirmationPage";
import ContactSelection from "./ContactSelection";
import IssueDescription from "./IssueDescription";
import LocationSelection from "./LocationSelection";
import ReviewPage from "./ReviewPage";
import TicketTypeSelection from "./TicketTypeSelection";
import ProductSelection from "./ProductSelection";
import PrioritySelection from "./PrioritySelection";

const CDN_URL = process.env.REACT_APP_CDN_URL;

const BillingSelected = `${CDN_URL}support/ticketing/icon-billing-selected-lg.svg`;
const OutageSelected = `${CDN_URL}support/ticketing/icon-outage-selected-lg.svg`;
const SupportSelected = `${CDN_URL}support/ticketing/icon-support-selected-lg.svg`;

const SCREENS = {
  TYPE: "type",
  LOCATION: "location",
  BILLING: "billing",
  ISSUE: "issue",
  PRODUCT: "product",
  PRIORITY: "priority",
  CONTACT: "contact",
  REVIEW: "review",
  CONFIRMATION: "confirmation",
};
const NavArrow = ({ className, enabled, onClick }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24.127"
    height="23.349"
    viewBox="0 0 24.127 23.349"
    className={`${className}`}
    onClick={onClick}
  >
    <path
      id="Triangle-Active"
      fill={enabled ? "#a2a9ad" : "#cfd2d3"}
      d="M9.221 0l9.221 16.314H0z"
      className="cls-1"
      transform="rotate(30 4.078 15.221)"
    />
  </svg>
);
const WIZARD_SCREEN = {
  POPULATE_BILLING: [
    { component: TicketTypeSelection, screen: SCREENS.TYPE },
    { component: BillingIssueSelection, screen: SCREENS.BILLING },
    { component: IssueDescription, screen: SCREENS.ISSUE },
    { component: ContactSelection, screen: SCREENS.CONTACT },
  ],
  POPULATE_PORTAL: [
    { component: TicketTypeSelection, screen: SCREENS.TYPE },
    { component: ProductSelection, screen: SCREENS.PRODUCT },
    { component: PrioritySelection, screen: SCREENS.PRIORITY },
    { component: IssueDescription, screen: SCREENS.ISSUE },
    { component: ContactSelection, screen: SCREENS.CONTACT },
  ],

  POPULATE_OUTAGE: [
    { component: TicketTypeSelection, screen: SCREENS.TYPE },
    { component: ProductSelection, screen: SCREENS.PRODUCT },
    { component: LocationSelection, screen: SCREENS.LOCATION },
    { component: IssueDescription, screen: SCREENS.ISSUE },
    { component: ContactSelection, screen: SCREENS.CONTACT },
  ],
  POPULATE_ILA: [
    { component: TicketTypeSelection, screen: SCREENS.TYPE },
    { component: LocationSelection, screen: SCREENS.LOCATION },
    { component: PrioritySelection, screen: SCREENS.PRIORITY },
    { component: IssueDescription, screen: SCREENS.ISSUE },
    { component: ContactSelection, screen: SCREENS.CONTACT },
  ],

  POPULATE: [
    { component: TicketTypeSelection, screen: SCREENS.TYPE },
    { component: ProductSelection, screen: SCREENS.PRODUCT },
    { component: LocationSelection, screen: SCREENS.LOCATION },
    { component: PrioritySelection, screen: SCREENS.PRIORITY },
    { component: IssueDescription, screen: SCREENS.ISSUE },
    { component: ContactSelection, screen: SCREENS.CONTACT },
  ],
  REVIEW: [{ component: ReviewPage, screen: SCREENS.REVIEW }],
  CONFIRMATION: [{ component: ConfirmationPage, screen: SCREENS.CONFIRMATION }],
};
const WIZARD_DEFAULT_TITLES = [
  { screen: "type", title: "What do you need help with?", subtitle: "" },
  {
    screen: "product",
    title: "Which product are you having trouble with?",
    subtitle: "",
  },
  {
    screen: "location",
    title: "Which location is your product located?",
    subtitle: "",
  },
  { screen: "priority", title: "Choose a  priority.", subtitle: "" },
  {
    screen: "issue",
    title: "Describe the problem you have.",
    subtitle: "Please be as descriptive as possible.",
  },
  {
    screen: "contact",
    title: "What's the best way to contact you?",
    subtitle: "",
  },
];
const WIZARD_DEFAULT_TITLES_PORTAL = [
  { screen: "type", title: "What do you need help with?", subtitle: "" },
  {
    screen: "product",
    title: "Which product are you having trouble with?",
    subtitle: "",
  },
  { screen: "priority", title: "Choose a  priority.", subtitle: "" },
  {
    screen: "issue",
    title: "Describe the problem you have.",
    subtitle: "Please be as descriptive as possible.",
  },
  {
    screen: "contact",
    title: "What's the best way to contact you?",
    subtitle: "",
  },
];
const WIZARD_DEFAULT_TITLES_OUTAGE = [
  { screen: "type", title: "What do you need help with?", subtitle: "" },
  {
    screen: "product",
    title: "Which product are you having trouble with?",
    subtitle: "",
  },
  {
    screen: "location",
    title: "Which location is your product located?",
    subtitle: "",
  },
  {
    screen: "issue",
    title: "Describe the problem you have.",
    subtitle: "Please be as descriptive as possible.",
  },
  {
    screen: "contact",
    title: "What's the best way to contact you?",
    subtitle: "",
  },
];
const WIZARD_DEFAULT_TITLES_ILA = [
  { screen: "type", title: "What do you need help with ?", subtitle: "" },
  { screen: "location", title: "Select your desired location ?", subtitle: "" },
  { screen: "priority", title: "Choose a  priority.", subtitle: "" },
  {
    screen: "issue",
    title: "Describe the problem you have.",
    subtitle: "Please be as descriptive as possible.",
  },
  {
    screen: "contact",
    title: "What's the best way to contact you?",
    subtitle: "",
  },
];
const WIZARD_DEFAULT_TITLES_BILLING = [
  { screen: "type", title: "What do you need help with?", subtitle: "" },
  {
    screen: "billing",
    title: "What is your billing issue related to?",
    subtitle: "Select from one of the options below",
  },
  {
    screen: "issue",
    title: "What do you need help with?",
    subtitle: "Please be as descriptive as possible.",
  },
  {
    screen: "contact",
    title: "What's the best way to contact you?",
    subtitle: "",
  },
  {
    screen: "contact",
    title: "What's the best way to contact you?",
    subtitle: "",
  },
  {
    screen: "contact",
    title: "What's the best way to contact you?",
    subtitle: "",
  },
];
const DIRECTION = {
  NEXT: "next",
  PREV: "prev",
};

const PHASES = {
  POPULATE: "POPULATE",
  REVIEW: "REVIEW",
  CONFIRMATION: "CONFIRMATION",
};
class IssueRequestWizard extends Component {
  constructor(props) {
    super(props);
    this.billingApi = new BillingApi();
    this.state = {
      data: {},
      screen: 0,
      phase: PHASES.POPULATE,
      wizardTitle: WIZARD_DEFAULT_TITLES[0].title,
      furthestIndex: 0,
      subtitle: "",
      invoices: null,
      services: null,
      ticketResponse: null,
    };
  }
  componentDidMount() {
    const {
      company_info: {
        customer: { id },
      },
    } = this.props;
    this.requestInvoices(id);
    this.getCompanyServices(id);
  }

  getCompanyServices = async (id) => {
    const { organizationServices, error } =
      await new UserProfileApi().getCompanyServices(id);

    this.setState({ services: organizationServices, error });
  };

  massageInvoices = (response) => {
    let massagedData = [];
    let invoiceData = [];
    const { data: { invoices = [], intacctInvoices = [] } = {} } = response;

    if (intacctInvoices && intacctInvoices.length !== 0) {
      this.setState({ intacct: true });
      const formattedInvoices =
        BillingUtils.formatIntacctInvoice(intacctInvoices);

      massagedData = BillingUtils.massageData(
        formattedInvoices,
        INVOICE_SUMMARY_HEADERS
      );
    }
    if (invoices && invoices.length !== 0) {
      invoiceData = BillingUtils.massageData(invoices, INVOICE_SUMMARY_HEADERS);
    }

    return [...massagedData, ...invoiceData];
  };

  requestInvoices = (id) => {
    const { company_info: { customer: { customerId = 0 } } = {} } = this.props;
    this.billingApi
      .getAll(id, null, customerId)
      .then((response) => {
        if (response.status === 200 && response.data) {
          const massagedData = this.massageInvoices(response);
          this.setState({ invoices: massagedData });
        }
      })
      .catch(() => {});
  };

  update = (screen, value) => {
    const { data } = this.state;
    data[screen] = value;
    this.setState({ data });
  };

  findNextScreen = (direction = DIRECTION.NEXT, stepCount = 1) => {
    const { phase, screen: currentScreenIndex, data } = this.state;

    if (phase === PHASES.POPULATE) {
      if (direction === DIRECTION.NEXT) {
        const nextScreen = currentScreenIndex + stepCount;
        if (nextScreen >= WIZARD_SCREEN.POPULATE.length) {
          return { phase: PHASES.REVIEW, nextScreen: 0 };
        } else if (
          nextScreen >= WIZARD_SCREEN.POPULATE_BILLING.length &&
          data.type === "billing"
        ) {
          return { phase: PHASES.REVIEW, nextScreen: 0 };
        } else if (
          nextScreen >= WIZARD_SCREEN.POPULATE_OUTAGE.length &&
          data.type === "outage"
        ) {
          return { phase: PHASES.REVIEW, nextScreen: 0 };
        } else if (
          nextScreen >= WIZARD_SCREEN.POPULATE_ILA.length &&
          data.type === "ila"
        ) {
          return { phase: PHASES.REVIEW, nextScreen: 0 };
        } else if (
          nextScreen >= WIZARD_SCREEN.POPULATE_PORTAL.length &&
          data.product === "Portal"
        ) {
          return { phase: PHASES.REVIEW, nextScreen: 0 };
        } else {
          return { phase: PHASES.POPULATE, nextScreen };
        }
      } else {
        const nextScreen = Math.max(currentScreenIndex - stepCount, 0);
        return { phase: PHASES.POPULATE, nextScreen };
      }
    }
  };
  navigateWizard = (direction = DIRECTION.NEXT) => {
    const { data } = this.state;
    const stepCount = 1;
    const { phase, nextScreen } = this.findNextScreen(direction, stepCount);
    const BillingWizardTitle =
      nextScreen === 2 && data.billing && data.billing[0] !== "general"
        ? `What do you need help with on invoice ${data.billing[0].invoice_number}?`
        : WIZARD_DEFAULT_TITLES_BILLING[nextScreen].title;

    const CustomTitle = this.getWizardTitle(nextScreen, data);
    let wizardTitle =
      data.type === "billing" ? BillingWizardTitle : CustomTitle;
    const subtitle =
      data.type === "billing"
        ? WIZARD_DEFAULT_TITLES_BILLING[nextScreen].subtitle
        : WIZARD_DEFAULT_TITLES[nextScreen].subtitle;
    wizardTitle =
      data?.type === "ila"
        ? WIZARD_DEFAULT_TITLES_ILA[nextScreen].title
        : wizardTitle;

    this.setState({
      phase,
      screen: nextScreen,
      wizardTitle,
      subtitle,
    });
  };
  getStepCount = (step, data) => {
    if (step === "location" && data.type === "outage") {
      return 1;
    }
  };
  getWizardTitle = (nextScreen) => {
    const { data } = this.state;
    let title = "";
    if (data.product && data.product !== "Portal" && nextScreen === 2) {
      title = `Which location is your ${data.product} located?`;
    } else if (
      data.product &&
      data.product !== "Portal" &&
      nextScreen === 4 &&
      data.type !== "outage"
    ) {
      title = `Describe the problem you have with ${data.product}.`;
    } else if (data.type === "outage") {
      title = WIZARD_DEFAULT_TITLES_OUTAGE[nextScreen].title;
    } else if (data.type === "ila") {
      title = WIZARD_DEFAULT_TITLES_ILA[nextScreen].title;
    } else if (data.product === "Portal") {
      title = WIZARD_DEFAULT_TITLES_PORTAL[nextScreen].title;
    } else {
      title = WIZARD_DEFAULT_TITLES[nextScreen].title;
    }
    return title;
  };
  setPriority = (type) => {
    if (type === "billing") {
      this.updateEditedData("priority", null, "medium");
    } else if (type === "outage") {
      this.updateEditedData("priority", null, "high");
    }
  };
  onSelect = (step, params, newData = false) => {
    const {
      furthestIndex: furthestRecordedIndex,
      data,
      statePhase,
      screen,
    } = this.state;
    const stepCount = this.getStepCount(step, data);
    const currentType = data && data.type ? data.type : "";

    const { phase, nextScreen } =
      !params.noSubmit || params.noSubmit === undefined
        ? this.findNextScreen(DIRECTION.NEXT, stepCount)
        : { phase: statePhase, nextScreen: screen };

    if (newData || !nextScreen) {
      let title;

      if (step === "type" && params.data !== currentType) {
        this.setState({ data: { type: params.data } });
      } else {
        this.setState((state) => {
          // eslint-disable-next-line
          state.data[step] = params.data;
          // eslint-disable-next-line
          state.wizardTitle = title;

          return state;
        });
      }

      if (step === "type") {
        this.setPriority(params.data);
      }

      if (!params.noSubmit) {
        this.setWizardTimeout(data, nextScreen, furthestRecordedIndex, phase);
      }
    }
  };
  setWizardTimeout = (data, nextScreen, furthestRecordedIndex, phase) => {
    this.timeout = setTimeout(() => {
      const BillingWizardTitle =
        nextScreen === 2 && data.billing && data.billing[0] !== "general"
          ? `What do you need help with on invoice ${data.billing[0].invoice_number}?`
          : WIZARD_DEFAULT_TITLES_BILLING[nextScreen].title;
      const CustomTitle = this.getWizardTitle(nextScreen, data);

      const wizardTitle =
        data.type === "billing" ? BillingWizardTitle : CustomTitle;
      const customSubtitle =
        data.type === "outage"
          ? WIZARD_DEFAULT_TITLES_OUTAGE[nextScreen].subtitle
          : WIZARD_DEFAULT_TITLES[nextScreen].subtitle;
      let subtitle =
        data.type === "billing"
          ? WIZARD_DEFAULT_TITLES_BILLING[nextScreen].subtitle
          : customSubtitle;
      subtitle =
        data.type === "ila"
          ? WIZARD_DEFAULT_TITLES_ILA[nextScreen].subtitle
          : customSubtitle;
      const title =
        phase === PHASES.POPULATE ? wizardTitle : "Review & submit when ready.";

      const furthestIndex =
        phase === PHASES.POPULATE
          ? Math.max(nextScreen, furthestRecordedIndex)
          : WIZARD_SCREEN.POPULATE.length;

      this.setState({
        screen: nextScreen,
        wizardTitle: title,
        phase,
        furthestIndex,
        subtitle,
      });
    }, 1000);
  };
  updateEditedData = (section, field, data) => {
    if (field) {
      this.setState((state) => {
        // eslint-disable-next-line
        state.data[section][field] = data;
        return state;
      });
    } else {
      this.setState((state) => {
        // eslint-disable-next-line
        state.data[section] = data;
        return state;
      });
    }
  };
  shouldDisableNav = (direction = DIRECTION.NEXT) => {
    const { screen, phase, furthestIndex } = this.state;

    if (direction === DIRECTION.NEXT) {
      return screen >= furthestIndex || phase === PHASES.REVIEW;
    } else {
      return phase === PHASES.REVIEW || screen === 0;
    }
  };
  generateTicketTitle(type, priority) {
    const timestamp = Date.now();

    let title = `SUPPORT-NORMAL-${timestamp}`;
    if (type && priority) {
      title = `${type.toUpperCase()}-${priority.toUpperCase()}-${timestamp}`;
    }

    return title;
  }
  formattedAttachments = (attachments) => {
    const { auth_status } = this.props;
    const formattedAttachments = [];

    attachments.forEach((attachment) => {
      const formattedAttachment = {
        user_id: auth_status.user.id,
        created_date_time: Date.now(),
        public_attachment: true,
        removed: false,
        attachment_location: attachment.data_id,
        filename: attachment.filename,
      };
      formattedAttachments.push(formattedAttachment);
    });
    return formattedAttachments;
  };
  formatBillingData = (data) => {
    if (!data) {
      return null;
    }
    return [
      {
        output_transaction: data.invoice_number,
        output_reference_id: data.invoiceId,
        amount: data.amount,
      },
    ];
  };

  formatDescription = (
    description,
    browser_info,
    preference,
    contactData,
    requester,
    billingDetails,
    userId,
    company_id,
    location,
    product,
    internalTicketReference
  ) => {
    let desc = "";
    desc = `Description: ${description} \n`;
    desc += `Support Request - ${product} \n`;
    desc += `Contact: ${contactData}  \n`;
    desc += `Preference: ${preference}  \n`;
    desc += `Company: ${company_id}  \n`;
    desc += `Location: ${location}  \n`;
    desc += `Requestor: ${requester}  \n`;
    desc += `Requestor ID: ${userId}  \n`;

    // Add shared user information if available
    const sharedUserData = sessionStorage.getItem("sharedUser");
    if (sharedUserData) {
      const { name, email } = JSON.parse(sharedUserData);
      desc += `Shared User Name: ${name}\n`;
      desc += `Shared User Email: ${email}\n`;
    }

    if (internalTicketReference && internalTicketReference !== "") {
      desc += `Internal Ticket Reference: ${internalTicketReference}\n`;
    }

    if (billingDetails) {
      desc += `Billing Details: ${billingDetails}  \n`;
    }
    desc += `Browser Info: ${browser_info}  \n`;

    return desc;
  };
  submitTicket = async () => {
    const { data } = this.state;
    const {
      auth_status,
      company_info,
      site,
      auth_status: {
        user: { id },
      },
      auth_status: {
        user: {
          userProfile: { emailAddress },
        },
      },
    } = this.props;
    const {
      issue: { description, attachments, internalTicketReference },
      contact: { preference, data: contactData },
      location,
      priority,
      product,
      type,
      billing,
    } = data;

    const dateSubmitted = new Date();

    const formattedAttachments = this.formattedAttachments(
      attachments,
      dateSubmitted
    );
    const requester = Utils.getRequester(auth_status);
    const browser_info = await Utils.getClientParams(site);
    const userId = id;
    const formattedDescription = this.formatDescription(
      description,
      browser_info,
      preference,
      contactData,
      requester,
      billing,
      userId,
      company_info?.customer?.id,
      location,
      product,
      internalTicketReference
    );

    const newTicket = {
      requester,
      requester_contact_type: preference,
      requester_contact_value: emailAddress,
      internalTicketReference: internalTicketReference
        ? internalTicketReference
        : "",
      requester_id: auth_status.user.id,
      public_request: null,
      status: "New",
      title: this.generateTicketTitle(type, priority),
      description: formattedDescription,
      priority,
      internal_priority: priority,
      type,
      request_type: type,
      request_method: "portal",
      service: product,
      process_id: 0,
      companyId: company_info?.customer?.id,
      user_id: auth_status.user.id,
      jira_ticket: "",
      location,
      impact_to_customer: "None",
      impact_to_dcblox: "None",
      resolution_notes: "",
      general_support_question_type: "",
      general_support_question: "",
      general_support_equipment: "",
      feedback_type: type,
      feedback_jira_ticket: "",
      feedback_browser_data: browser_info,
      billing_detail: this.formatBillingData(billing ? billing[0] : null),
      outage_details: [],
      related_tickets: [],
      assignes: [],
      request_log: [],
      comments: [],
      attachments: formattedAttachments,
      notifications: [],
      related_services: [],
      test_results: [],
      userId,
    };

    TicketApi.createTicket(newTicket)
      .then((response) =>
        this.handleSubmitResponse(response, newTicket, dateSubmitted)
      )
      .catch((error) =>
        this.handleSubmitResponse({ error }, newTicket, dateSubmitted)
      );
  };
  handleSubmitResponse = (response) => {
    sessionStorage.removeItem("tickets");
    this.setState({ ticketResponse: response, phase: PHASES.CONFIRMATION });
  };
  submitTickets = () => {
    this.submitTicket();
  };
  getScreen = () => {
    const { phase, screen, data, invoices, services, ticketResponse } =
      this.state;
    const {
      closeModal,
      breakpoint,
      auth_status,
      navigate,
      pages,
      location,
      ticketType,
    } = this.props;

    let Screen;

    if (
      phase === PHASES.POPULATE &&
      data.type !== "billing" &&
      data.type !== "outage" &&
      data.type !== "ila" &&
      data.product !== "Portal"
    ) {
      Screen = WIZARD_SCREEN.POPULATE[screen].component;
    } else if (phase === PHASES.POPULATE && data.type === "billing") {
      Screen = WIZARD_SCREEN.POPULATE_BILLING[screen].component;
    } else if (phase === PHASES.POPULATE && data.type === "outage") {
      Screen = WIZARD_SCREEN.POPULATE_OUTAGE[screen].component;
    } else if (phase === PHASES.POPULATE && data.product === "Portal") {
      Screen = WIZARD_SCREEN.POPULATE_PORTAL[screen].component;
    } else if (phase === PHASES.POPULATE && data.type === "ila") {
      Screen = WIZARD_SCREEN.POPULATE_ILA[screen].component;
    } else if (phase === PHASES.REVIEW) {
      Screen = WIZARD_SCREEN.REVIEW[0].component;
    } else if (phase === PHASES.CONFIRMATION) {
      Screen = WIZARD_SCREEN.CONFIRMATION[0].component;
    }

    return (
      <Screen
        data={data}
        onSelect={this.onSelect}
        updateTitle={this.updateTitle}
        update={this.update}
        closeModal={closeModal}
        invoices={invoices}
        services={services}
        breakpoint={breakpoint}
        auth_status={auth_status}
        updateData={this.updateEditedData}
        submitTicket={this.submitTickets}
        ticketResponse={ticketResponse}
        navigate={navigate}
        pages={pages}
        location={location}
        ticketType={ticketType}
      />
    );
  };
  getCustomClassName = (currentIndex, index) => {
    if (currentIndex === index) {
      return "dot active";
    } else if (currentIndex > index) {
      return "dot completed";
    } else {
      return "dot";
    }
  };

  getProgressDots = (currentIndex) => {
    const { data } = this.state;
    const filterDots =
      data.type === "billing" ? [1, 2, 3, 4] : [1, 2, 3, 4, 5, 6];
    let dots =
      data.type === "outage" || data.product === "Portal"
        ? [1, 2, 3, 4, 5]
        : filterDots;
    dots = data.type === "ila" ? [1, 2, 3, 4, 5] : dots;
    return (
      <div className="progress-dots">
        {dots.map((dot, index) => (
          <div
            className={this.getCustomClassName(currentIndex, index)}
            key={dot}
          />
        ))}
      </div>
    );
  };

  getIcon(type) {
    switch (type) {
      case "billing":
        return BillingSelected;
      case "outage":
        return OutageSelected;
      default:
        return SupportSelected;
    }
  }

  render() {
    const {
      data,
      screen: currentScreenIndex,
      phase,
      wizardTitle,
      furthestIndex,
      subtitle,
    } = this.state;

    return (
      <div className="issue-request-container">
        <div className="issue-request-wizard">
          {phase !== PHASES.CONFIRMATION && (
            <div className="wizard-header">
              {currentScreenIndex !== 0 && (
                <div className="wizard-nav">
                  <div key="left-nav-arrow-key" className="left-nav-arrow-key">
                    <NavArrow
                      className={`left-arrow wizard-nav ${
                        this.shouldDisableNav(DIRECTION.PREV) ? "disabled" : ""
                      }`}
                      onClick={
                        this.shouldDisableNav(DIRECTION.PREV)
                          ? () => {}
                          : () => this.navigateWizard(DIRECTION.PREV)
                      }
                      enabled={!this.shouldDisableNav(DIRECTION.PREV)}
                    />
                  </div>
                  {this.getProgressDots(currentScreenIndex, furthestIndex)}
                  <div
                    key={`right-nav-arrow-key${
                      Number(screen) === 0 ? "-hidden" : ""
                    }`}
                    className="right-nav-arrow-key"
                  >
                    <NavArrow
                      className={`right-arrow wizard-nav ${
                        this.shouldDisableNav(DIRECTION.NEXT) ? "disabled" : ""
                      } ${
                        currentScreenIndex === 0 &&
                        phase === PHASES.POPULATE &&
                        furthestIndex > 0
                          ? "allow"
                          : ""
                      }`}
                      onClick={
                        this.shouldDisableNav(DIRECTION.NEXT)
                          ? () => {}
                          : () => this.navigateWizard(DIRECTION.NEXT)
                      }
                      enabled={!this.shouldDisableNav(DIRECTION.NEXT)}
                    />
                  </div>
                </div>
              )}
              {phase === PHASES.REVIEW && (
                <div className="wizard-ticket-icon">
                  <img src={this.getIcon(data.type)} />
                </div>
              )}

              <div className="wizard-title heading60">
                {wizardTitle}
                {subtitle && <div className="sub-title body20">{subtitle}</div>}
              </div>
            </div>
          )}
          <div className="wizard-body">{this.getScreen()}</div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    site: state.site_tracking,
    auth_status: state.auth_status,
    company_info: state.company_info,
  };
}

export default connect(mapStateToProps, {
  updateModule,
  updatePage,
  addPageToBreadCrumbs,
})(IssueRequestWizard);
